<template>
    <div>
        <b-container fluid>
            <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
            <b-row no-gutters class="mt-3 mb-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id
                                ? $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Client',
                                      'Edit',
                                      true
                                  )
                                : $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Client',
                                      'Create',
                                      true
                                  )
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitClientForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
            <b-card class="mb-1">
                <FormInput
                    :canEditFields="canEditFields"
                    :validateState="validateState"
                    :getErrorMessages="getErrorMessages"
                    :data="cms_client_obj"
                    :onChangeData="onChangeData"
                />
            </b-card>

            <b-row no-gutters class="mt-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id
                                ? $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Client',
                                      'Edit',
                                      true
                                  )
                                : $store.state.user_obj &&
                                  checkPermission(
                                      $store.state.user_obj,
                                      'Account',
                                      'Client',
                                      'Create',
                                      true
                                  )
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitClientForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength } from "vuelidate/lib/validators";
import FormInput from "./common/FormInput";
import global_function from "../mixins/global_function";

export default {
    name: "AccountForm",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "ERROR_MESSAGES"],
    mixins: [validationMixin, global_function],
    components: {
        FormInput
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: "Clients",
                    to: { name: "cms_client" }
                },
                {
                    text: "Form",
                    active: true
                }
            ],

            loader: false,
            cms_client_obj: {},
        };
    },
    async created() {
        await this.getClient();

        if (this.$route.params.client_id) {
            this.edit_mode = true;
        }
        this.initialized = true;
    },
    validations: {
        cms_client_obj: {
            client_name: {
                required
            },
            full_name: {
                required
            },
            enable_shopify: {},
            description: {},
            api_key: {},
            api_secret: {},
            base_url: {},
            shared_secret: {},
            skip_product: {}
        }
    },
    computed: {
        canEditFields: function() {
            return [
                {
                    type: "text",
                    key: "client_name",
                    label: "* Client Name"
                },
                {
                    type: "text",
                    key: "full_name",
                    label: "* Full Name"
                },
                {
                    type: "checkbox",
                    key: "enable_shopify",
                    label: "Enable Shopify"
                },
                {
                    type: "text",
                    key: "description",
                    label: "Description",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
                {
                    type: "text",
                    key: "api_key",
                    label: "API Key",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
                {
                    type: "text",
                    key: "api_secret",
                    label: "API Secret",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
                {
                    type: "text",
                    key: "base_url",
                    label: "Base URL",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
                {
                    type: "text",
                    key: "shared_secret",
                    label: "Shared Secret",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
                {
                    type: "checkbox",
                    key: "skip_product",
                    label: "Skip Product",
                    hidden: this.cms_client_obj.enable_shopify != 1
                },
            ]
        }
    },
    mounted() {},
    watch: {},
    methods: {
        async getClient() {
            if (!this.$route.params.client_id) {
                this.cms_client_obj = {
                    skip_product: 0,
                    enable_shopify: 0,
                };
                return;
            }
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_client_profile_get.php",
                data: {
                    client_profile_id: this.$route.params.client_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.cms_client_obj = response.data.clients[0];

            console.log(this.cms_client_obj);
        },

        validateState(name) {
            const { $dirty, $error } = this.$v.cms_client_obj[name];
            return $dirty ? !$error : null;
        },

        getErrorMessages(key) {
            let validators = Object.keys(this.$v.cms_client_obj[key].$params);
            let errors = validators
                .filter(v => this.$v.cms_client_obj[key][v] === false)
                .map(v => this.ERROR_MESSAGES[v]);
            return errors;
        },

        async submitClientForm() {
            this.$v.cms_client_obj.$touch();
            if (this.$v.cms_client_obj.$anyError) {
                return;
            }

            let params = {
                cms_client_obj: this.cms_client_obj,
                user_id: this.$store.state.user_obj.user_id,
                client_profile_id: this.$store.state.user_obj.client_id,
            };
            console.log(params)

            let req_url = "cms_client_profile_add.php";

            if (this.$route.params.client_id) {
                params.client_profile_id = this.$route.params.client_id;
                req_url = "cms_client_profile_edit.php";
            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: req_url,
                data: params
            });

            if (response.data.status === "fail") {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: response.data.error,
                    variant: "danger"
                });
            } else {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: "Update User Success"
                });

                this.$router.go(-1);
            }
        },
        onChangeData: function(data) {
            this.cms_client_obj = data;
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.file_document {
    display: none;
}

.preview_img-product {
    max-width: 100%;
    max-height: 200px;
}

.container-preview_img {
    padding: 5px;
}

.icon-add_image {
    color: #cacaca;
}

.col-image {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-group {
    margin-bottom: 0;
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsClientForm.vue